module.exports = __webpack_public_path__ + "static/img/miyazawa_02.436683f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/miyazawa_02.png
// module id = HajB
// module chunks = 0